<template>
    <div class="ah-page bank-account-detail-page">
        <div class="page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <el-button style="margin-right: 12px;" icon="el-icon-arrow-left" size="small" @click="$router.push({ name: 'bank-account' })" @keypress="() => {}">回列表</el-button>
                        <h1 style="display: inline-block; vertical-align: middle;">銀行帳戶明細</h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="row main-color" style="padding-bottom: 30px">
            <div class="ah-container">
                <el-row :gutter="20">
                    <el-col :sm="12">
                        <table class="ah-basic-data-table white" style="margin-left: 20px; font-size: 10.5pt;">
                            <tbody>
                                <tr>
                                    <th>帳戶簡稱：</th>
                                    <td>{{ setting.tpc }}</td>
                                </tr>
                                <tr>
                                    <th>銀行：</th>
                                    <td>
                                        ({{ setting.bnK_BOO }})
                                        {{ setting.bnK_DOO_NAM }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>帳號：</th>
                                    <td>{{ setting.bnK_ACC }}</td>
                                </tr>
                                <tr>
                                    <th>幣別：</th>
                                    <td>{{ setting.cny }}</td>
                                </tr>
                                <tr>
                                    <th>帳戶啟用日期</th>
                                    <td>
                                        {{ setting.dat | dateFormater("YYYY-MM-dd") }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </el-col>
                    <el-col :sm="12">
                        <div class="ah-card main-color">
                            <div class="content">
                                <div class="statis-title">
                                    當前餘額
                                </div>
                                <div class="statis-num">
                                    <Money :v="setting.amt" :precision="setting.cny === 'TWD' ? null : 4" />
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="ah-container" style="margin-top: 20px">
            <div class="ah-panel">
                <div class="panel-body" style="border-bottom: 1px solid #eee">
                    <el-select v-model="queryParams.Year" @input="fetchData(true, true)" size="small" style="width: 130px; margin-right: 10px;">
                        <el-option v-for="year in yearOptions" :key="year" :label="`${year}年`" :value="year"></el-option>
                    </el-select>
                    <el-radio-group v-model="queryParams.Month" size="small" @input="fetchData(true, true)">
                        <el-radio-button v-for="m in 12" :key="m" :label="m">{{ m }}月</el-radio-button>
                    </el-radio-group>
                    <div style="text-align: right;">
                        <el-pagination
                            layout="prev, pager, next"
                            :page-size.sync="queryParams.PageSize"
                            :total.sync="totalDataCount"
                            :current-page.sync="queryParams.PageNum"
                            :small="isMobile()"
                            @current-change="fetchData(true)"
                        >
                        </el-pagination>
                    </div>
                </div>
                <div class="panel-body">
                    <el-table v-loading="isLoading" :data="datas" style="width: 100%" class="ah-el-data-table" empty-text="沒有資料">
                        <el-table-column label="交易日期" width="120">
                            <template slot-scope="scope">
                                <span>{{ scope.row.dat | dateFormater("YYYY-MM-dd") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="類型" width="120">
                            <template slot-scope="scope">
                                <span>
                                    <span v-if="scope.row.typ == 0">初始金額</span>
                                    <span v-if="scope.row.typ == 1">請款單</span>
                                    <span v-if="scope.row.typ == 2">發票</span>
                                    <span v-if="scope.row.typ == 3">財務收入</span>
                                    <span v-if="scope.row.typ == 4">財務支出</span>
                                    <span v-if="scope.row.typ == 5">零用金提出</span>
                                    <span v-if="scope.row.typ == 6">零用金轉入</span>
                                    <span v-if="scope.row.typ == 7">薪資支出</span>
                                    <span v-if="scope.row.typ == 8">發票折讓</span>
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="number" label="單號" width="150">
                            <template slot-scope="scope">
                                <div>
                                    <div v-if="scope.row.typ == 1">
                                        <span class="detail-row-sn" @click="openPayment(scope.row.sno)" @keydown="() => {}">{{ scope.row.number }}</span>
                                    </div>
                                    <div v-else-if="scope.row.typ == 2">
                                        <span class="detail-row-sn" @click="openInvoice(scope.row.sno)" @keydown="() => {}">{{ scope.row.number }}</span>
                                    </div>
                                    <div v-else-if="scope.row.typ == 3">
                                        <span class="detail-row-sn" @click="openVariable(scope.row.sno)" @keydown="() => {}">{{ scope.row.number }}</span>
                                    </div>
                                    <div v-else-if="scope.row.typ == 4">
                                        <span class="detail-row-sn" @click="openVariable(scope.row.sno)" @keydown="() => {}">{{ scope.row.number }}</span>
                                    </div>
                                    <div v-else>
                                        {{ scope.row.number }}
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="summary" label="摘要" :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div v-if="scope.row.summary">
                                    {{ scope.row.summary }}
                                </div>
                                <div v-else style="color: #ccc">(無)</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="amt" width="120" label="請領金額" align="right">
                            <template slot-scope="scope">
                                <div v-if="scope.row.amt < 0" style="color: red">
                                    <Money :v="scope.row.amt" :precision="setting.cny === 'TWD' ? null : 4" />
                                </div>
                                <div v-else>
                                    <Money :v="scope.row.amt" :precision="setting.cny === 'TWD' ? null : 4" />
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="cny" width="50" label="" align="right"> </el-table-column>
                        <el-table-column prop="balance" width="" label="結餘" align="right">
                            <template slot-scope="scope">
                                <Money :v="scope.row.balance" :precision="setting.cny === 'TWD' ? null : 4" />
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        layout="prev, pager, next"
                        :page-size.sync="queryParams.PageSize"
                        :total.sync="totalDataCount"
                        :current-page.sync="queryParams.PageNum"
                        :small="isMobile()"
                        @current-change="fetchData(true)"
                        class="pagination"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
        <PaymentDetailDialog @close="handlePaymentDetailDialogClose" :visible="paymentDetailDialog.visible" :sno="paymentDetailDialog.sno" />
        <InvoiceDetailDialog @close="handleInvoiceDetailDialogClose" :visible="invoiceDetailDialog.visible" :sno="invoiceDetailDialog.sno" />
        <VariableDetailDialog
            ref="variableDetailDialog"
            :visible="variableDetailDialog.visible"
            :sno="variableDetailDialog.sno"
            @edit="onEditDialogVisibleChange"
            @close="handleVariableDetailDialogClose"
        />
        <VariableStatementEditDialog
            :sno="variableEditDialog.sno"
            :visible="variableEditDialog.visible"
            :purpose="variableEditDialog.purpose"
            @refresh="onEditDialogRefresh"
            @close="onEditDialogVisibleChange"
        />
    </div>
</template>
<script>
import PaymentDetailDialog from '@/components/dashboard/Payment/PaymentDetailDialog.vue';
import InvoiceDetailDialog from '@/components/dashboard/Invoice/InvoiceDetailDialog.vue';
import VariableDetailDialog from '@/components/dashboard/Finance/VariableStatement/DetailDialog.vue';
import VariableStatementEditDialog from '@/components/dashboard/Finance/VariableStatement/EditDialog.vue';

export default {
    components: {
        PaymentDetailDialog,
        InvoiceDetailDialog,
        VariableDetailDialog,
        VariableStatementEditDialog,
    },
    data() {
        return {
            isLoading: false,
            queryParams: {
                BNK_SNO: 1,
                Year: null,
                Month: null,
                PageNum: 1,
                PageSize: 25,
            },
            invoiceDetailDialog: {
                visible: false,
                sno: null,
            },
            paymentDetailDialog: {
                visible: false,
                sno: null,
            },
            variableDetailDialog: {
                visible: false,
                sno: null,
            },
            variableEditDialog: {
                visible: false,
                sno: null,
                purpose: null,
            },
            totalDataCount: 0,
            yearOptions: [],
            datas: [],
            setting: {
                sno: null,
                amt: null,
                bnK_ACC: '',
                bnK_BOO: '',
                bnK_DOO: '',
                bnK_NAM: '',
                bnK_DOO_NAM: '',
                bnK_BOO_NAM: '',
                cny: '',
                cnynam: '',
                dat: null,
                isUsed: null,
                original_AMT: null,
                totalNum: null,
                tpc: '',
                wrN_AMT: 0,
                wrN_FLG: 0,
            },
        };
    },
    computed: {},
    created() {
        this.initYearOptions();

        this.queryParams.BNK_SNO = Number(this.$route.query.sno);
        this.queryParams.Year = Number(this.$route.query.year);
        this.queryParams.Month = Number(this.$route.query.month);
        this.queryParams.PageNum = Number(this.$route.query.page || 1);

        if (!this.queryParams.Year || !this.queryParams.Month) {
            const currentDate = new Date();
            this.queryParams.Year = currentDate.getFullYear();
            this.queryParams.Month = currentDate.getMonth() + 1;
        }

        this.fetchData();
    },
    methods: {
        initYearOptions() {
            const thisYear = new Date().getFullYear();
            this.yearOptions = [];
            for (let y = thisYear + 1; y >= 2020; y--) {
                this.yearOptions.push(y);
            }
        },
        fetchData(isUpdateUrlQuery = false, isResetPage = false) {
            this.isLoading = true;

            if (isUpdateUrlQuery) {
                this.$router.replace({
                    query: {
                        sno: this.queryParams.BNK_SNO,
                        year: this.queryParams.Year,
                        month: this.queryParams.Month,
                        page: this.queryParams.PageNum,
                    },
                });
            }
            if (isResetPage) this.queryParams.PageNum = 1;

            this.$api({
                url: 'BankAccountSettingPage/GetReceiptAndDisbursementStatement',
                params: {
                    BNK_SNO: this.queryParams.BNK_SNO,
                    Year: this.queryParams.Year,
                    Month: this.queryParams.Month,
                    PageNum: this.queryParams.PageNum,
                    PageSize: this.queryParams.PageSize,
                },
                method: 'GET',
            })
                .then((resp) => {
                    this.datas = resp.data.items;
                    this.setting = resp.data.setting;
                    this.totalDataCount = resp.data.totalNum;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        openPayment(sno) {
            this.paymentDetailDialog.sno = sno;
            this.paymentDetailDialog.visible = true;
        },
        openInvoice(sno) {
            this.invoiceDetailDialog.sno = sno;
            this.invoiceDetailDialog.visible = true;
        },
        openVariable(sno) {
            this.variableDetailDialog.sno = sno;
            this.variableDetailDialog.visible = true;
        },
        handlePaymentDetailDialogClose(refresh) {
            this.paymentDetailDialog.visible = false;
            this.paymentDetailDialog.sno = null;
            if (refresh) {
                this.fetchData();
            }
        },
        handleInvoiceDetailDialogClose(refresh) {
            this.invoiceDetailDialog.visible = false;
            this.invoiceDetailDialog.sno = null;
            if (refresh) {
                this.fetchData();
            }
        },
        handleVariableDetailDialogClose(refresh) {
            this.variableDetailDialog.visible = false;
            this.variableDetailDialog.sno = null;
            if (refresh) {
                this.fetchData();
            }
        },
        onEditDialogVisibleChange({ visible, purpose, sno = null }) {
            if (!visible) {
                this.variableEditDialog.purpose = null;
                this.variableEditDialog.sno = null;
            }
            this.variableEditDialog.visible = visible;
            this.variableEditDialog.purpose = purpose;
            this.variableEditDialog.sno = sno;
        },
        onEditDialogRefresh() {
            this.fetchData();
            this.$refs.variableDetailDialog.refresh();
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.bank-account-detail-page {
    .detail-row-sn {
        cursor: pointer;

        &:hover {
            color: #000;
            text-decoration: underline;
        }
    }
}
</style>
